import {Hash} from "../interfaces/hashInterfaces";

export let UrlHelper = {
  parseQuery(url: string): Hash<string> {
    const result = {};
    if (url.includes('?')) {
      const query = url.split('?')[1];
      query.split('&').forEach(q => {
        const keyVal = q.split('=');
        result[keyVal[0]] = keyVal[1];
      });
    }
    return result;
  },
  updateQuery(url: string, queryToUpdate: string, value: string): {url: string, query: object} {
    const path = url.split('?')[0];
    const query = UrlHelper.parseQuery(url);
    query[queryToUpdate] = value;
    url = `${path}?${$.param(query)}`;
    // returns both the new url string with updated query, and just the updated query object
    return {url, query}
  }
};
